export default __webpack_public_path__ + "static/media/updateOrder.e741149f.png";